import React from "react";
import Signature from "@components/Signature";
import EmployeeCertificate from "@components/PaySlip/EmployeeCertificate";
import OfficeAddress from "@components/OfficeAddress";
import PayslipTable from "@components/PaySlip/PayslipTable";
import CertificateMessage from "@components/PaySlip/CertificateMessage";
import EmployeeDetail from "@components/PaySlip/EmployeeDetail";

export class PaySlipPrint extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      employee_id: employee,
      employee_name,
      signature,
      purpose,
      start_date,
      end_date,
      payslip_data,
    } = this.props.slipData;
    return (
      <div id="printContianer" style={PayrollWrapper}>
        <style>
          {`
            @media print {
              @page {
                size: portrait;
              }
              @page {
                margin-top: 2rem;
              }
            }
          `}
        </style>
        <br />
        <h5 style={PayrollHeader}>Salary Slip</h5>
        <br />
        <OfficeAddress />
        <EmployeeDetail
          machine_no={employee?.machine_no}
          joining_date={employee?.joining_date}
          employee_name={employee_name}
          start_date={start_date}
          end_date={end_date}
        />
        <EmployeeCertificate
          name={employee_name}
          gender={employee?.gender}
          cnic={employee?.national_id_number}
          position={employee?.job_title}
          joiningDate={employee?.joining_date}
          months={payslip_data?.length}
        />
        <PayslipTable payslipData={payslip_data} />
        <CertificateMessage purpose={purpose} />
        <Signature label={signature} />
      </div>
    );
  }
}

const PayrollWrapper = {
  fontFamily: "Arial, Helvetica, sans-serif",
  padding: "0px 25px 0px 25px",
  margin: "0",
  width: "100%",
};

const PayrollHeader = {
  textAlign: "center",
  fontWeight: "bold",
  fontSize: "28px",
  marginTop: "1rem",
};
